/* Sommaire des pages /policies/* : construit depuis les h2 du texte impose
   par Shopify, pose dans la colonne collante sous le titre. Libelle recu du
   layout (data-libelle sur la balise script), jamais ecrit ici. Rien ne
   change au balisage si le texte n'a pas au moins deux titres. */
(function () {
  var script = document.currentScript;
  var libelle = script && script.getAttribute('data-libelle');
  var corps = document.querySelector('.shopify-policy__body .rte');
  var titre = document.querySelector('.shopify-policy__title');
  if (!corps || !titre || !libelle) return;
  var titres = Array.prototype.slice.call(corps.querySelectorAll('h2'));
  if (titres.length < 2) return;

  var nav = document.createElement('nav');
  nav.className = 'politique__sommaire';
  nav.setAttribute('aria-label', libelle);
  var etiquette = document.createElement('p');
  etiquette.className = 'politique__sommaire-titre';
  etiquette.textContent = libelle;
  var liste = document.createElement('ol');
  titres.forEach(function (h2, i) {
    if (!h2.id) h2.id = 'politique-' + (i + 1);
    var item = document.createElement('li');
    var lien = document.createElement('a');
    lien.href = '#' + h2.id;
    lien.textContent = h2.textContent.trim();
    item.appendChild(lien);
    liste.appendChild(item);
  });
  nav.appendChild(etiquette);
  nav.appendChild(liste);
  titre.appendChild(nav);
})();
